export default {
    namespaced: true,
    state: {
        all: [
            { name: "Home", route: "/", icon: "home" },
        ],
        superAdmin: [
            {
                name: "Admin",
                icon: "security",
                children: [
                    { name: "APIs", route: "/admin/apis", icon: "flash_auto" },
                    { name: "Fronts", route: "/admin/fronts", icon: "devices" },
                    {
                        name: "Service Accounts",
                        route: "/admin/service-accounts",
                        icon: "settings"
                    },
                    { name: "Scopes", route: "/admin/scopes", icon: "pages" },
                    { name: "Roles", route: "/admin/roles", icon: "policy" },
                    { name: "Organizations", route: "/admin/organizations", icon: "apartment" },
                    { name: "Users", route: "/admin/users", icon: "people" }
                ]
            }
        ],
        admin: [
            {
                name: "Orga",
                icon: "apartment",
                children: [
                    { name: "Users", route: "/access/users", icon: "people" },
                ]
            }
        ],
        access: [
            {
                name: "Access",
                icon: "supervised_user_circle",
                children: [
                    { name: "Groups", route: "/access/groups", icon: "group_add" },
                    { name: "Rights", route: "/access/rights", icon: "local_dining" },
                ]
            }
        ]
    },
}
